import { OrderControllerService } from 'shared/api/generatedApi/services/OrderControllerService';
import { OrderRequestDto, OrderResponseDto } from 'shared/api';

export const orderApi = {
  getOrders: (
    userId?: number,
    engineId?: number,
    status?: OrderResponseDto.status,
    workType?: OrderResponseDto.workType,
  ) => OrderControllerService.findOrders(userId, engineId, status, workType),
  getOrderById: (id: number) => OrderControllerService.findOrderById(id),
  createOrder: (data: OrderRequestDto) => OrderControllerService.createOrder(data),
  updateOrder: (id: number, data: OrderRequestDto) => OrderControllerService.updateOrder(id, data),
  deleteOrder: (id: number) => OrderControllerService.deleteOrder(id),
  completeOrder: async (id: number, reportFileUuid: string) => {
    // Получаем существующие данные заявки
    const existingOrder = await OrderControllerService.findOrderById(id);

    // Обновляем заявку со статусом COMPLETED и UUID файла
    const updateData = {
      engineId: existingOrder.engineId || 0,
      workType: existingOrder.workType as OrderRequestDto.workType,
      status: OrderRequestDto.status.COMPLETED,
      reportFileUuids: [reportFileUuid],
      comment: existingOrder.comment,
    };

    return OrderControllerService.updateOrder(id, updateData);
  },
};
